import { createSlice } from "@reduxjs/toolkit";
import { fetchPreRegisterWidgets } from "../actions/preRegisterActions";

const initialState = {
  widgets: [],
  byType: {
    guest: null,
    premium: null,
    free: null,
  },
  loading: false,
  error: null,
};

function normalizeWidgets(payload) {
  const widgets = Array.isArray(payload?.widgets) ? payload.widgets : [];
  const byType = { guest: null, premium: null, free: null };

  widgets.forEach((w) => {
    const name = w?.subscription_types?.[0]?.name;
    if (name && Object.prototype.hasOwnProperty.call(byType, name)) {
      byType[name] = w;
    }
  });

  return { widgets, byType };
}

const preRegisterSlice = createSlice({
  name: "preRegister",
  initialState,
  reducers: {
    resetPreRegister: (state) => {
      state.widgets = [];
      state.byType = { guest: null, premium: null, free: null };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPreRegisterWidgets.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPreRegisterWidgets.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      const { widgets, byType } = normalizeWidgets(action.payload);
      state.widgets = widgets;
      state.byType = byType;
    });
    builder.addCase(fetchPreRegisterWidgets.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || action.error?.message || true;
    });
  },
});

export const { resetPreRegister } = preRegisterSlice.actions;
export default preRegisterSlice.reducer;
